import React, { useContext, useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import supabase from "../supabase/supabaseClient";
import estilo from "./styles/VerVideo.module.css";

import Video from "../components/Video";
import TarjetasVideo from "../components/TarjetasVideo";
import { tiempoTranscurrido } from "../utils/tiempo";
import { DataContext } from "../context/DataContext";
import MetaDecorator from "../utils/MetaDecorator";

function VerVideo() {
  let params = useParams();

  const { activarBuscador } = useContext(DataContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [params.id]);

  const [usuarios, setUsuarios] = useState([]);
  const [videos, setVideos] = useState([]);

  //filtrar y actualizar video
  useEffect(() => {
    const fecthUsuarios = async () => {
      const { data, error } = await supabase
        .from("usuarios")
        .select()
        .eq("nombre", params.id);

      if (data) {
        // console.log(data);
        setUsuarios(data);

        let vistas = data[0].visualizaciones + 1;
        await supabase
          .from("usuarios")
          .update({ visualizaciones: vistas })
          .eq("nombre", params.id);
      }
      if (error) {
        console.log(error);
      }
    };

    fecthUsuarios();
  }, [params.id]);

  //traer lista de videos
  useEffect(() => {
    const fetchVideos = async () => {
      const { data, error } = await supabase.from("usuarios").select();

      if (data) {
        // console.log(data);
        setVideos(data.sort(() => Math.random() - 0.5).slice(0, 6));
      }
      if (error) {
        console.log(error);
      }
    };

    fetchVideos();
  }, [params.id]);

  const fechaActual = new Date();

  useEffect(() => {
    function handleScroll() {
      if (window.innerWidth <= 576) {
        const menus = document.querySelectorAll("#menu");
        const divSobreNosotros = document.querySelector("#inicio");
        const { top } = divSobreNosotros.getBoundingClientRect();
        if (top < -10) {
          menus.forEach((menu) => {
            menu.classList.add(estilo.bg);
          });
        } else if (top > -10) {
          menus.forEach((menu) => {
            menu.classList.remove(estilo.bg);
          });
        }
      }
    }

    window.addEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={estilo.ver_video} onClick={() => activarBuscador(false)}>
      {usuarios.map((e, i) => (
        <MetaDecorator
          key={i}
          titulo={e.nombre}
          subtitulo={e.nombre}
          descripcion={e.descripcion}
        ></MetaDecorator>
      ))}

      {usuarios.map((e, i) => (
        <div key={i} className={estilo.video}>
          <Video usuario={e.usuario}></Video>

          <div className={estilo.informacion} id="menu">
            <h3>{e.nombre}</h3>

            <div className={estilo.datos}>
              <div className={estilo.datos_usuario}>
                <div className={estilo.dato_icono}>
                  <svg width="70" height="70" viewBox="0 0 24 24">
                    <path d="M12 2C6.579 2 2 6.579 2 12s4.579 10 10 10 10-4.579 10-10S17.421 2 12 2zm0 5c1.727 0 3 1.272 3 3s-1.273 3-3 3c-1.726 0-3-1.272-3-3s1.274-3 3-3zm-5.106 9.772c.897-1.32 2.393-2.2 4.106-2.2h2c1.714 0 3.209.88 4.106 2.2C15.828 18.14 14.015 19 12 19s-3.828-.86-5.106-2.228z"></path>
                  </svg>
                </div>

                <div className={estilo.dato_cantidad}>
                  <h4>{e.usuario}</h4>
                  <p>850 suscriptores</p>
                </div>

                <div className={estilo.suscribete}>
                  <p>Suscribete</p>
                </div>
              </div>

              <div className={estilo.dato_opciones}>
                <div className={estilo.boton_like}>
                  <div className={estilo.boton}>
                    <svg width="28" height="28" viewBox="0 0 24 24">
                      <path d="M20 8h-5.612l1.123-3.367c.202-.608.1-1.282-.275-1.802S14.253 2 13.612 2H12c-.297 0-.578.132-.769.36L6.531 8H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h13.307a2.01 2.01 0 0 0 1.873-1.298l2.757-7.351A1 1 0 0 0 22 12v-2c0-1.103-.897-2-2-2zM4 10h2v9H4v-9zm16 1.819L17.307 19H8V9.362L12.468 4h1.146l-1.562 4.683A.998.998 0 0 0 13 10h7v1.819z"></path>
                    </svg>
                    <p>12</p>
                  </div>

                  <div className={estilo.boton}>
                    <svg width="28" height="28" viewBox="0 0 24 24">
                      <path d="M20 3H6.693A2.01 2.01 0 0 0 4.82 4.298l-2.757 7.351A1 1 0 0 0 2 12v2c0 1.103.897 2 2 2h5.612L8.49 19.367a2.004 2.004 0 0 0 .274 1.802c.376.52.982.831 1.624.831H12c.297 0 .578-.132.769-.36l4.7-5.64H20c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-8.469 17h-1.145l1.562-4.684A1 1 0 0 0 11 14H4v-1.819L6.693 5H16v9.638L11.531 20zM18 14V5h2l.001 9H18z"></path>
                    </svg>
                    <p>3</p>
                  </div>
                </div>

                <div className={estilo.boton_compartir}>
                  <svg width="28" height="28" viewBox="0 0 24 24">
                    <path d="M11 7.05V4a1 1 0 0 0-1-1 1 1 0 0 0-.7.29l-7 7a1 1 0 0 0 0 1.42l7 7A1 1 0 0 0 11 18v-3.1h.85a10.89 10.89 0 0 1 8.36 3.72 1 1 0 0 0 1.11.35A1 1 0 0 0 22 18c0-9.12-8.08-10.68-11-10.95zm.85 5.83a14.74 14.74 0 0 0-2 .13A1 1 0 0 0 9 14v1.59L4.42 11 9 6.41V8a1 1 0 0 0 1 1c.91 0 8.11.2 9.67 6.43a13.07 13.07 0 0 0-7.82-2.55z"></path>
                  </svg>
                  <p>Compartir</p>
                </div>

                <div className={estilo.boton_guardar}>
                  <svg width="28" height="28" viewBox="0 0 24 24">
                    <path d="M19 15v-3h-2v3h-3v2h3v3h2v-3h3v-2h-.937zM4 7h11v2H4zm0 4h11v2H4zm0 4h8v2H4z"></path>
                  </svg>
                  <p>Guardar</p>
                </div>
              </div>
            </div>
          </div>

          <div className={estilo.descripcion} id="menu">
            <div className={estilo.tiempo}>
              <p>{e.visualizaciones} vistas</p>
              <p>{tiempoTranscurrido(e.created_at, fechaActual)}</p>
            </div>

            <div className={estilo.descripcion_texto}>
              <p>{e.descripcion}</p>
            </div>
          </div>

          <div>comentarios</div>
        </div>
      ))}

      {videos && (
        <div className={estilo.tarjetas}>
          {videos.map((e, i) => (
            <TarjetasVideo key={i} e={e} variante={null}></TarjetasVideo>
          ))}
        </div>
      )}
    </div>
  );
}

export default VerVideo;
